import classes from './LargeImageAndTextBlock.module.css.mjs';

const largeImageAndTextBlockTextPositionClasses = {
  center: classes.largeImageAndTextBlockTextContentCenter,
  left: classes.largeImageAndTextBlockTextContentLeft
};
const largeImageAndTextBlockImageAspectRatioClasses = {
  "text-over-image": classes.largeImageAndTextBlockImageAspectRatioTextOverImage,
  "full-bleed-text-over-image": classes.largeImageAndTextBlockImageAspectRatioFullBleedTextOverImage,
  "text-and-image-blocks": classes.largeImageAndTextBlockImageAspectRatioTextAndImageBlocks
};
const largeImageAndTextBlockImageContainerClasses = {
  "text-over-image": classes.largeImageAndTextBlockImageContainerTextOverImage,
  "full-bleed-text-over-image": classes.largeImageAndTextBlockImageContainerFullBleedTextOverImage,
  "text-and-image-blocks": classes.largeImageAndTextBlockImageContainerTextAndImageBlocks
};

export { largeImageAndTextBlockImageAspectRatioClasses, largeImageAndTextBlockImageContainerClasses, largeImageAndTextBlockTextPositionClasses };
